/*
    ORCA RQueryREST Service Helper.

    @Copyright 2015 ORCA Intel orca-intel.com All Rights Reserved.
*/

window.RQApp                   = { };
window.RQDate                  = { };
window.RQueryRESTServiceHelper = { };

RQApp.ViewModel                = { };
RQApp.IsPageContext            = false;
RQApp.IsPageLoaded             = false;
RQApp.PageParams               = { };

RQueryRESTServiceHelper.RQueryAPIKey    = "NO_API_KEY";
RQueryRESTServiceHelper.RQueryAuthToken = "";

if (sessionStorage.getItem("RQueryAPIKey")) {
    RQueryRESTServiceHelper.RQueryAPIKey = sessionStorage.getItem(
        "RQueryAPIKey"
    );
}

if (sessionStorage.getItem("RQueryAuthToken")) {
    RQueryRESTServiceHelper.RQueryAuthToken = sessionStorage.getItem(
        "RQueryAuthToken"
    );
}

RQApp.Name           = "ORCA Application";

RQApp.EntryPoint     = function() { };

RQApp.ZeroDate       = new Date(1900 ,1 ,1 ,0 ,0 ,0 ,0);

RQApp.SetSession     = function(rqAPIKey ,rqAuthToken) {
    RQueryRESTServiceHelper.RQueryAPIKey    = rqAPIKey;
    RQueryRESTServiceHelper.RQueryAuthToken = rqAuthToken;

    sessionStorage.setItem("RQueryAPIKey"    ,rqAPIKey);
    sessionStorage.setItem("RQueryAuthToken" ,rqAuthToken);
};

RQApp.GetAPIKey    = function () { return RQueryRESTServiceHelper.RQueryAPIKey;    };
RQApp.GetAuthToken = function () { return RQueryRESTServiceHelper.RQueryAuthToken; };

/* Override these in app controller */
RQApp.HandleSessionExpiry  = function ()                         { };
RQApp.HandleTimeout        = function (serviceName ,commandName) { };
RQApp.HandleNetworkError   = function (serviceName ,commandName) { };
RQApp.ShowDialog           = function (message     ,callback)    { };

RQApp.AppExit              = function () {
    RQueryRESTServiceHelper.RQueryAuthToken = "";

    sessionStorage.setItem("RQueryAuthToken" ,"");

    RQApp.HandleSessionExpiry();
};

RQApp.HandleRQConfigResult = function(configResult) { };

RQApp.ErrorHandlers        = { };

RQApp.LangCodesByID        = [
     '' ,'en-US' ,'fr' ,'de' ,'it' ,'es' ,'pt' ,'tr' ,'hu' ,'nl'
];

RQApp.FormatMoney = function (money, langID) {
    if (langID < 1 || langID > 9) { langID = 1; }

    return money.toLocaleString(
         RQApp.LangCodesByID[langID]
        ,{ minimumFractionDigits: 2 ,maximumFractionDigits: 2 }
    );
};

RQApp.DateAsUTC = function (date) {
    var result = new Date(date);

    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());

    return result;
};

RQApp.DateDiffDays = function (startDate ,endDate) {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;

    return (
        (RQApp.DateAsUTC(endDate) - RQApp.DateAsUTC(startDate))
      / (millisecondsPerDay)
    );
};

RQDate.JSDateToRQString = function(jsDate, withMilliseconds) {
    if (!(Object.prototype.toString.call(jsDate) === "[object Date]")) {
        return "RQDate: not supplied a date object";
    }
    
    var rqString     = "RQDate";
    var day          = jsDate.getDate();
    var month        = jsDate.getMonth() + 1;
    var year         = jsDate.getFullYear();
    var hour         = jsDate.getHours();
    var minute       = jsDate.getMinutes();
    var seconds      = jsDate.getSeconds();
    var milliseconds = jsDate.getMilliseconds();
    
    if (day     < 10) { day     = "0" + day;     }
    if (month   < 10) { month   = "0" + month;   }
    if (hour    < 10) { hour    = "0" + hour;    }
    if (minute  < 10) { minute  = "0" + minute;  }
    if (seconds < 10) { seconds = "0" + seconds; }
    
    if      (milliseconds < 10)  { milliseconds = "00" + milliseconds; }
    else if (milliseconds < 100) { milliseconds = "0"  + milliseconds; }
    
    rqString = "" + year + "-" + month + "-" + day;
    
    if (!
        (
           (hour         == "00")
        && (minute       == "00")
        && (seconds      == "00")
        && (milliseconds == "000" || (!withMilliseconds))
        )
    ) {
        rqString += " " + hour + ":" + minute + ":" + seconds;
        
        if (withMilliseconds) { rqString += "." + milliseconds; }
    }
    
    return rqString;
};

RQApp.JSDateToRQString = RQDate.JSDateToRQString;

RQueryRESTServiceHelper.TimeoutHandler = function(
     serviceName
    ,commandName
) {
    /* handle RQuery timeouts here */
    sessionStorage.setItem("RQueryAuthToken" ,"");
    
    RQueryRESTServiceHelper.RQueryAuthToken = "";
    
    RQApp.HandleTimeout(serviceName ,commandName);
};

RQueryRESTServiceHelper.NetworkErrorHandler = function (
     serviceName
    ,commandName
) {
    /* handle service endpoint connection errors here */
    sessionStorage.setItem("RQueryAuthToken" ,"");

    RQueryRESTServiceHelper.RQueryAuthToken = "";

    RQApp.HandleNetworkError(serviceName ,commandName);
};

RQueryRESTServiceHelper.ResultHandler = function(
     serviceName
    ,commandName
    ,rpcResult
) { 
    var count = rpcResult.RQueryResult.length;
    
    rpcResult.HasError            = false;
    rpcResult.HasException        = false;
    rpcResult.HasErrorOrException = false;
    
    /* marshall date strings */
    for (var i=0; i < count; i++) {
        var row = rpcResult.RQueryResult[i];
    
        for (var field in row) {
            if (
                row.hasOwnProperty(field)
            &&  field.substr(0, 4)                         ==  "date"
            &&  Object.prototype.toString.call(row[field]) === "[object Date]"
            ) {
                var strPartner = field.substr(4);
                
                if (row.hasOwnProperty(strPartner)) {
                    row[strPartner] = RQDate.JSDateToRQString(
                         row[field] ,true
                    );
                }
            }
        }
    }
    
    /* handle rpcError and rpcException */
    if (count > 0) {
        var first = rpcResult.RQueryResult[0];
        
        /* handle rpcException */
        if (first.hasOwnProperty("ExceptionThrown") && first.ExceptionThrown) {
            var logToken = '';

            if (
                serviceName == "PMS"
            &&  commandName == "RegisterPMSException"
            ) { logToken = "RQLogFailure "; }

            rpcResult.HasException        = true;
            rpcResult.HasErrorOrException = true;
            
            throw new Error(
                logToken
              + "remote exception (session faulted): "
              + first.Message
            );
        }
        
        /* handle rpcError */
        if (
            (first.hasOwnProperty("ErrorCode"))
        &&  (first.ErrorCode != 0)
        &&  (serviceName     != "Extensions")
        ) {
            var message = "(" + first.ErrorCode + ") " + first.ErrorMessage;

            rpcResult.HasError            = true;
            rpcResult.HasErrorOrException = true;
            
            /* call handlers */
            if (
                first.ErrorCode == 9009
            ||  first.ErrorCode == 9010
            ||  first.ErrorCode == 9011
            ) {
                console.log('session expiry error: ' + message);

                RQApp.HandleSessionExpiry();

                return;
            }
            
            if (
                RQApp.ErrorHandlers["Handle" + first.ErrorCode] !== undefined
            ) {
                RQApp.ErrorHandlers["Handle" + first.ErrorCode]();
                
                return;
            }
            
            /* show error dialog */
            RQApp.ShowDialog(message);
            
            return;
        }
    }
    
    /* call user defined handler if exists */
    if (
        RQHandlers.hasOwnProperty(serviceName)
    &&  RQHandlers[serviceName].hasOwnProperty(commandName)
    ) {
        return RQHandlers[serviceName][commandName](rpcResult);
    }

    return rpcResult;
};


//////////////////
// WEBPACK FOOTER
// ./src/RQuery/RQueryRESTServiceHelper.js
// module id = 405
// module chunks = 0